import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass],
  selector: 'aux-ag-check-rerender',
  styles: [
    `
      :host {
        display: inline-flex;
      }
    `,
  ],
  template: `
    <aux-icon
      [name]="value ? 'Check' : 'X'"
      [ngClass]="value ? 'text-aux-green-dark' : 'text-aux-red-dark-2'"
    />
  `,
})
export class AgCheckRerenderComponent implements ICellRenderer {
  value = false;

  agInit(params: ICellRendererParams) {
    this.value = params.value;
  }

  refresh(): boolean {
    return false;
  }
}
